var Vendd = (function (Vendd) {
    'use strict';

    Vendd.User = (function (User) {

        User.Messages = (function (Messages) {

            Messages.Login = function (loginName, password, rememberMe, loginRedirectUrl, logoutRedirectUrl, reCaptchaCode, accessToken, options) {
                var data = {
                    loginName: loginName,
                    password: password,
                    rememberMe: rememberMe,
                    loginRedirectUrl: loginRedirectUrl,
                    logoutRedirectUrl: logoutRedirectUrl,
                    reCaptchaCode: reCaptchaCode,
                    accessToken: accessToken,
                    options: options || {}
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.Login', data);
            };
            Messages.Login.className = 'Vendd.User.Messages.Login';

            Messages.SsoLogin = function () {
                var data = {};

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.SsoLogin', data);
            };
            Messages.SsoLogin.className = 'Vendd.User.Messages.SsoLogin';

            Messages.SsoRegister= function () {
                var data = {};

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.SsoRegister', data);
            };
            Messages.SsoRegister.className = 'Vendd.User.Messages.SsoRegister';

            Messages.LoginSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.LoginSuccess', response);
            };
            Messages.LoginSuccess.className = 'Vendd.User.Messages.LoginSuccess';

            Messages.LoginFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.LoginFailure', response);
            };
            Messages.LoginFailure.className = 'Vendd.User.Messages.LoginFailure';


            Messages.Logout = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.Logout', {});
            };
            Messages.Logout.className = 'Vendd.User.Messages.Logout';

            Messages.LogoutAuthProviders = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.LogoutAuthProviders', {});
            };
            Messages.LogoutAuthProviders.className = 'Vendd.User.Messages.LogoutAuthProviders';

            Messages.LogoutUser = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.LogoutUser', {});
            };
            Messages.LogoutUser.className = 'Vendd.User.Messages.LogoutUser';

            Messages.LogoutSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.LogoutSuccess', response);
            };
            Messages.LogoutSuccess.className = 'Vendd.User.Messages.LogoutSuccess';

            Messages.LogoutFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.LogoutFailure', response);
            };
            Messages.LogoutFailure.className = 'Vendd.User.Messages.LogoutFailure';


            Messages.ForgotPassword = function (email) {
                var data = {
                    email: email
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.ForgotPassword', data);
            };
            Messages.ForgotPassword.className = 'Vendd.User.Messages.ForgotPassword';

            Messages.ForgotPasswordSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.ForgotPasswordSuccess', response);
            };
            Messages.ForgotPasswordSuccess.className = 'Vendd.User.Messages.ForgotPasswordSuccess';

            Messages.ForgotPasswordFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.ForgotPasswordFailure', response);
            };
            Messages.ForgotPasswordFailure.className = 'Vendd.User.Messages.ForgotPasswordFailure';


            Messages.ResetPassword = function (code, password, passwordConfirmation) {
                var data = {
                    code: code,
                    password: password,
                    passwordConfirmation: passwordConfirmation
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.ResetPassword', data);
            };
            Messages.ResetPassword.className = 'Vendd.User.Messages.ResetPassword';

            Messages.ResetPasswordSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.ResetPasswordSuccess', response);
            };
            Messages.ResetPasswordSuccess.className = 'Vendd.User.Messages.ResetPasswordSuccess';

            Messages.ResetPasswordFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.ResetPasswordFailure', response);
            };
            Messages.ResetPasswordFailure.className = 'Vendd.User.Messages.ResetPasswordFailure';

            Messages.ResendActivationCode = function (code, type) {
                var data = {
                    activationCode: code,
                    notificationType: type
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.ResendActivationCode', data);
            };
            Messages.ResendActivationCode.className = 'Vendd.User.Messages.ResendActivationCode';

            Messages.ResendActivationCodeSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.ResendActivationCodeSuccess', response);
            };
            Messages.ResendActivationCodeSuccess.className = 'Vendd.User.Messages.ResendActivationCodeSuccess';

            Messages.ResendActivationCodeFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.ResendActivationCodeFailure', response);
            };
            Messages.ResendActivationCodeFailure.className = 'Vendd.User.Messages.ResendActivationCodeFailure';

            Messages.Register = function (firstName, lastName, email, username, password, passwordConfirmation, newsletter, reCaptchaCode, redirectUrl, phone, mobilephone, socialSecurityNumber, birthdate, isLoyaltyMember, loyaltyRequest, ReceiveEinvoice, loyaltyMemberId, preventRedirect, loyaltyMemberCardNumber, postalCode, sfmRegistrationRequest) {
                var data = {
                    "firstName": firstName,
                    "lastName": lastName,
                    "email": email,
                    "username": username,
                    "password": password,
                    "passwordConfirmation": passwordConfirmation,
                    "newsletter": newsletter,
                    "reCaptchaCode": reCaptchaCode,
                    "redirectUrl": redirectUrl,
                    "phone": phone,
                    "mobilephone": mobilephone,
                    "socialSecurityNumber": socialSecurityNumber,
                    "BirthDate": birthdate,
                    "IsLoyaltyMember": isLoyaltyMember,
                    "LoyaltyRequest": loyaltyRequest,
                    "ReceiveEinvoice": ReceiveEinvoice,
                    "LoyaltyMemberId": loyaltyMemberId,
                    "preventRedirect": preventRedirect,
                    "loyaltyMemberCardNumber": loyaltyMemberCardNumber,
                    "postalCode": postalCode,
                    "sfmRegistrationRequest": sfmRegistrationRequest
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.Register', data);
            };
            Messages.Register.className = 'Vendd.User.Messages.Register';

            Messages.CompleteSsoRegistration = function (newsletter, redirectUrl, phone, mobilePhone, socialSecurityNumber, isLoyaltyMember, loyaltyRequest, loyaltyMemberId, preventRedirect, loyaltyMemberCardNumber, postalCode, sfmRegistrationRequest) {
                var data = {
                    "newsletter": newsletter || false,
                    "redirectUrl": redirectUrl,
                    "phone": phone,
                    "mobilePhone": mobilePhone,
                    "socialSecurityNumber": socialSecurityNumber,
                    "isLoyaltyMember": isLoyaltyMember || false,
                    "loyaltyRequest": loyaltyRequest || false,
                    "loyaltyMemberId": loyaltyMemberId,
                    "preventRedirect": preventRedirect,
                    "loyaltyMemberCardNumber": loyaltyMemberCardNumber,
                    "postalCode": postalCode,
                    "sfmRegistrationRequest": sfmRegistrationRequest
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.CompleteSsoRegistration', data);
            };
            Messages.CompleteSsoRegistration.className = 'Vendd.User.Messages.CompleteSsoRegistration';

            Messages.RegisterSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.RegisterSuccess', response);
            };
            Messages.RegisterSuccess.className = 'Vendd.User.Messages.RegisterSuccess';

            Messages.RegisterFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.RegisterFailure', response);
            };
            Messages.RegisterFailure.className = 'Vendd.User.Messages.RegisterFailure';

            Messages.CanRegister = function (loginName, reCaptchaCode) {
                var data = {
                    "loginName": loginName,
                    "reCaptchaCode": reCaptchaCode
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.CanRegister', data);
            };
            Messages.CanRegister.className = 'Vendd.User.Messages.CanRegister';

            Messages.CanRegisterSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.CanRegisterSuccess', response);
            };
            Messages.CanRegisterSuccess.className = 'Vendd.User.Messages.CanRegisterSuccess';

            Messages.CanRegisterFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.CanRegisterFailure', response);
            };
            Messages.CanRegisterFailure.className = 'Vendd.User.Messages.CanRegisterFailure';

            Messages.B2BRegister = function
                (companyname, occupation, taxagency, taxidentifier, officername, vatstatus, email, emailconfirmation, username, town, address, number, postalcode, phone, password, passwordconfirmation,
                storesnumber, phoneTwo, mobile, socialSecurityNumber, fax, siteurl, store, companyCategory, openingHours, area, prefecture, officerLastName, officerPosition, message, newsletter, ReceiveEinvoice, reCaptchaCode, redirecturl, countryCode) {
                var data = {
                    "companyName": companyname,
                    "occupation": occupation,
                    "taxAgency": taxagency,
                    "taxIdentifier": taxidentifier,
                    "officerName": officername,
                    "vatStatus": vatstatus,
                    "email": email,
                    "emailConfirmation": emailconfirmation,
                    "username": username,
                    "town": town,
                    "address": address,
                    "addressNumber": number,
                    "postalCode": postalcode,
                    "phone": phone,
                    "password": password,
                    "passwordConfirmation": passwordconfirmation,
                    "storesNumber": storesnumber,
                    "secondPhone": phoneTwo,
                    "mobile": mobile,
                    "socialSecurityNumber": socialSecurityNumber,
                    "fax": fax,
                    "siteUrl": siteurl,

                    "store": store,
                    "companyCategory": companyCategory,
                    "openingHours": openingHours,
                    "area": area,
                    "prefecture": prefecture,
                    "officerLastName": officerLastName,
                    "officerPosition": officerPosition,

                    "message": message,
                    "newsletter": newsletter,
                    "reCaptchaCode": reCaptchaCode,
                    "ReceiveEinvoice": ReceiveEinvoice,
                    "redirectUrl": redirecturl,

                    "countryCode": countryCode
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.B2BRegister', data);
            };
            Messages.B2BRegister.className = 'Vendd.User.Messages.B2BRegister';

            Messages.B2BRegisterSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.B2BRegisterSuccess', response);
            };
            Messages.B2BRegisterSuccess.className = 'Vendd.User.Messages.B2BRegisterSuccess';

            Messages.B2BRegisterFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.B2BRegisterFailure', response);
            };
            Messages.B2BRegisterFailure.className = 'Vendd.User.Messages.B2BRegisterFailure';

            Messages.GetAreasForPostCode = function (countryCode, postalCode, selectedAreaCode) {
                var data = {
                    countryCode: countryCode,
                    postalCode: postalCode,
                    selectedAreaCode: selectedAreaCode 
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.GetAreasForPostCode', data);
            };
            Messages.GetAreasForPostCode.className = 'Vendd.User.Messages.GetAreasForPostCode';

            Messages.GetAreasForPostCodeSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.GetAreasForPostCodeSuccess', response);
            };
            Messages.GetAreasForPostCodeSuccess.className = 'Vendd.User.Messages.GetAreasForPostCodeSuccess';

            Messages.GetAreasForPostCodeFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.GetAreasForPostCodeFailure', response);
            };
            Messages.GetAreasForPostCodeFailure.className = 'Vendd.User.Messages.GetAreasForPostCodeFailure';

            Messages.CreateUser = function (firstName, lastName, email, username, redirectUrl) {
                var data = {
                    "firstName": firstName,
                    "lastName": lastName,
                    "email": email,
                    "username": username,
                    "redirectUrl": redirectUrl
            };
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.CreateUser', data);
            };
            Messages.CreateUser.className = 'Vendd.User.Messages.CreateUser';

            Messages.CreateUserSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.CreateUserSuccess', response);
            };
            Messages.CreateUserSuccess.className = 'Vendd.User.Messages.CreateUserSuccess';

            Messages.CreateUserFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.CreateUserFailure', response);
            };
            Messages.CreateUserFailure.className = 'Vendd.User.Messages.CreateUserFailure';

            Messages.UserInitialized = function (isAuthenticated) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.UserInitialized', {
                    isAuthenticated: isAuthenticated
                });
            };
            Messages.UserInitialized.className = 'Vendd.User.Messages.UserInitialized';

            Messages.GetUserViewModel = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.GetUserViewModel', {});
            };
            Messages.GetUserViewModel.className = 'Vendd.User.Messages.GetUserViewModel';

            Messages.GetUserViewModelSuccess = function (model) {
                var data = {
                    model: model
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.GetUserViewModelSuccess', data);
            };
            Messages.GetUserViewModelSuccess.className = 'Vendd.User.Messages.GetUserViewModelSuccess';

            Messages.GetUserViewModelFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.GetUserViewModelFailed', response);
            };
            Messages.GetUserViewModelFailed.className = 'Vendd.User.Messages.GetUserViewModelFailed';

            Messages.QuoteSubmit = function (email, userName, message, skuId) {
                var data = {
                    email: email,
                    userName: userName,
                    message: message,
                    skuId: skuId
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.QuoteSubmit', data);
            };
            Messages.QuoteSubmit.className = 'Vendd.User.Messages.QuoteSubmit';

            Messages.QuoteSubmitSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.QuoteSubmitSuccess', response);
            };
            Messages.QuoteSubmitSuccess.className = 'Vendd.User.Messages.QuoteSubmitSuccess';

            Messages.QuoteSubmitFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.QuoteSubmitFailure', response);
            };
            Messages.QuoteSubmitFailure.className = 'Vendd.User.Messages.QuoteSubmitFailure';

            Messages.LoginRedirect = function (envelope) {
                var data = envelope.message.data;
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.LoginRedirect', data);
            }
            Messages.LoginRedirect.className = 'Vendd.User.Messages.LoginRedirect';

            Messages.GetSessionState = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.GetSessionState', {});
            }
            Messages.GetSessionState.className = 'Vendd.User.Messages.GetSessionState';

            Messages.GetSessionStateSuccess = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.GetSessionStateSuccess', data);
            }
            Messages.GetSessionStateSuccess.className = 'Vendd.User.Messages.GetSessionStateSuccess';

            Messages.GetMemberByLoyaltyNumber = function (loyaltyMemberCardNumber) {
                var data = {
                    loyaltyMemberCardNumber: loyaltyMemberCardNumber
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.GetMemberByLoyaltyNumber', data);
            };
            Messages.GetMemberByLoyaltyNumber.className = 'Vendd.User.Messages.GetMemberByLoyaltyNumber';

            Messages.GetMemberByLoyaltyNumberSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.GetMemberByLoyaltyNumberSuccess', data);
            };
            Messages.GetMemberByLoyaltyNumberSuccess.className = 'Vendd.User.Messages.GetMemberByLoyaltyNumberSuccess';

            Messages.GetMemberByLoyaltyNumberFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.User.Messages.GetMemberByLoyaltyNumberFailed', response);
            };
            Messages.GetMemberByLoyaltyNumberFailed.className = 'Vendd.User.Messages.GetMemberByLoyaltyNumberFailed';

            return Messages;

        })(User.Messages || {});

        return User;

    })(Vendd.User || {});

    return Vendd;

})(Vendd || {});